import {
  TextInput,
  Create,
  SimpleForm,
  required,
  maxLength,
  regex,
  number,
  ReferenceInput,
  SelectInput,
  DateField,
  FormDataConsumer
} from "react-admin";
import { crm, cep, state } from "../../../normalize";
import { OTHER_ADDRESS_TYPE_ID } from "../constants";
import { ALPHANUMERIC_REGEX, CEP_REGEX } from "../../../constants/regex";

const widthInputs = { width: "260px" };
const validateRequired = required();
const validateNumber = [required(), number()];
const validateZipCode = [required(), regex(CEP_REGEX, "Digite um CEP válido.")];
const validateState = [required(), maxLength(2)];
const validateOtherAddressType = [
  maxLength(50),
  regex(ALPHANUMERIC_REGEX, "Somente letras e números são permitidos."),
];

const requiredIfTypeAddressId6 = (value, allValues) => {
  if (allValues.typeAddressId === OTHER_ADDRESS_TYPE_ID && !value) {
    return "Campo obrigatório quando o tipo de endereço for 'Outros'";
  }
  return undefined;
};

const AddressCreate = (props) => (
  <Create redirect="list" title="Novo Endereço" {...props}>
    <SimpleForm
      transform={data => {
        if (data.typeAddressId !== OTHER_ADDRESS_TYPE_ID) {
          delete data.otherAddressType;
        }
        return data;
      }}
    >
      <TextInput
        disabled
        label="Origem do Endereço"
        source="source"
        defaultValue="admin"
        style={widthInputs}
      />
      <ReferenceInput
        sort={{ field: "name", order: "ASC" }}
        perPage={999}
        resource="typeUser.id"
        source="typeUser"
        reference="type-users"
        

      >
        <SelectInput 
          style={widthInputs} 
          label="Tipo de Documento" 
          optionText="type" 
          optionValue="id"
          validate={validateRequired}
        />
      </ReferenceInput>
      <TextInput
        label="Documento"
        source="user.document"
        validate={validateRequired}
        normalize={crm}
        resettable
      />
      <ReferenceInput
        source="typeAddressId"
        reference="address/type-address"
        sort={{ field: "name", order: "ASC" }}
        perPage={1000}
      >
        <SelectInput
          style={widthInputs}
          label="Tipo de Endereço"
          optionText="name"
          optionValue="id"
          defaultValue={1}
        />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData }) =>
          formData.typeAddressId === OTHER_ADDRESS_TYPE_ID && (
            <TextInput
              label="Outro Tipo de Endereço *"
              source="otherAddressType"
              validate={[...validateOtherAddressType, requiredIfTypeAddressId6]}
              resettable
              style={widthInputs}
            />
          )
        }
      </FormDataConsumer>
      <TextInput
        label="CEP"
        source="cep"
        normalize={cep}
        validate={validateZipCode}
        resettable
      />
      <TextInput
        label="Endereço"
        source="address"
        validate={validateRequired}
        resettable
      />
      <TextInput label="Número" source="number" validate={validateNumber} resettable />
      <TextInput label="Complemento" source="complement" resettable />
      <TextInput
        label="Bairro"
        source="district"
        validate={validateRequired}
        resettable
      />
      <TextInput label="Cidade" source="city" validate={validateRequired} resettable />
      <TextInput
        label="Estado (UF)"
        source="state"
        validate={validateState}
        normalize={state}
        resettable
      />
      <DateField 
        label="Data de Criação"
        source="createdAt"
      />
    </SimpleForm>
  </Create>
);

export default AddressCreate;
